
document.addEventListener('DOMContentLoaded', () => {
  // Desktop Mega Menu Logic
  const triggers = document.querySelectorAll(
    '.header-new__nav-link--has-mega'
  );
  const overlay = document.querySelector('[data-mega-overlay]');

  const html = document.documentElement;
  const body = document.body;
  let scrollPosition = 0;
  let activeTrigger = null;

  if (triggers.length && overlay) {
    const megas = document.querySelectorAll('[data-mega-menu]');

    /**
     * Close all mega menus and restore accessibility attributes
     * @param {boolean} skipScrollRestore - Skip restoring scroll position if transitioning
     */
    const closeAll = (skipScrollRestore = false) => {
      megas.forEach((menu) => {
        menu.classList.remove('is-open');
      });
      overlay.classList.remove('is-active');
      html.classList.remove('mega-open');

      // Reset overlay inline styles
      overlay.style.top = '';
      overlay.style.left = '';
      overlay.style.right = '';
      overlay.style.bottom = '';
      overlay.style.width = '';
      overlay.style.height = '';
      overlay.style.position = '';

      if (activeTrigger) {
        activeTrigger.classList.remove('header-new__nav-link--mega-open');
        activeTrigger = null;
      }

      // Remove mega-menu-open class from header when mega menu closes
      const headerWrapper = document.querySelector('.section-header-new');
      if (headerWrapper) {
        headerWrapper.classList.remove('mega-menu-open');
      }

      // Only restore body scroll position and unlock scrolling if not transitioning
      if (!skipScrollRestore) {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        window.scrollTo(0, scrollPosition);
      }
      // If skipScrollRestore is true, keep body locked - openFor will handle the transition
    };

    /**
     * Open mega menu and update accessibility attributes
     * @param {HTMLElement} mega - The mega menu element to open
     * @param {HTMLElement} trigger - The trigger element that opened the menu
     */
    const openFor = (mega, trigger) => {
      // Save current scroll position FIRST before any DOM changes
      // If body is already fixed (transitioning between menus), extract scroll from top value
      let currentScroll = scrollPosition;
      if (body.style.position === 'fixed' && body.style.top) {
        // Already locked, extract scroll from top value to preserve position
        const topValue = body.style.top;
        const match = topValue.match(/-(\d+)px/);
        if (match) {
          currentScroll = parseInt(match[1], 10);
        }
      } else {
        // Not locked yet, get from window
        currentScroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
      }
      scrollPosition = currentScroll;
      
      // Close any open menus but skip scroll restore since we're opening a new one
      closeAll(true);

      // Lock body scroll immediately to prevent any jumping
      // Update the top value to maintain current scroll position
      body.style.position = 'fixed';
      body.style.top = `-${scrollPosition}px`;
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';

      // Position overlay to cover entire viewport (full screen overlay)
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.right = '0';
      overlay.style.bottom = '0';
      overlay.style.position = 'fixed';
      overlay.style.width = '100vw';
      overlay.style.height = '100vh';
      
      // Add mega-menu-open class to header when mega menu opens (for homepage transparency)
      const headerWrapper = document.querySelector('.section-header-new');
      if (headerWrapper) {
        if (document.body.classList.contains('is-homepage')) {
          headerWrapper.classList.add('mega-menu-open');
        }
      }

      mega.classList.add('is-open');
      overlay.classList.add('is-active');
      html.classList.add('mega-open');

      if (trigger) {
        trigger.classList.add('header-new__nav-link--mega-open');
        activeTrigger = trigger;
      }
    };

    /**
     * Set up event listeners for mega menu triggers
     * Supports both mouse and keyboard navigation for accessibility
     */
    triggers.forEach((trigger) => {
      const wrapper = trigger.closest('.header-new__mega-wrapper');
      if (!wrapper) return;
      const mega = wrapper.querySelector('[data-mega-menu]');
      if (!mega) return;

      // Mouse interaction
      trigger.addEventListener('mouseenter', () => {
        openFor(mega, trigger);
      });
    });

    /* Hovering non‑mega header links should close any open mega menu */
    const nonMegaLinks = document.querySelectorAll(
      '.header-new__nav-link:not(.header-new__nav-link--has-mega)'
    );
    nonMegaLinks.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        closeAll();
      });
    });

    /* Overlay hover or click closes mega menu */
    overlay.addEventListener('mouseenter', (e) => {
      e.stopPropagation();
      closeAll();
    });
    overlay.addEventListener('mouseover', (e) => {
      e.stopPropagation();
      closeAll();
    });
    overlay.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeAll();
    });

    // Global Escape key handler to close mega menu
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && html.classList.contains('mega-open')) {
        closeAll();
      }
    });
  }

  // Mobile Menu Logic
  // Support both legacy IDs and the new header IDs so the script works
  // regardless of which header implementation is used.
  const mobileMenuDrawer =
    document.querySelector('#menu-drawer-new') ||
    document.querySelector('#menu-drawer');
  const mobileMenuMain = document.querySelector('.header-new__mobile-menu-main');
  const mobileMenuMega = document.querySelector('.header-new__mobile-menu-mega');
  const mobileMegaTriggers = document.querySelectorAll('[data-mobile-mega-trigger]');
  const mobileMegaBack = document.querySelector('[data-mobile-mega-back]');
  const mobileDrawerClose = document.querySelector('.header-new__mobile-drawer-close');
  const mobileDrawerDetails =
    document.querySelector('#Details-menu-drawer-container-new') ||
    document.querySelector('#Details-menu-drawer-container');

  if (mobileMenuDrawer && mobileMenuMain && mobileMenuMega) {
    // Mobile drawer overlay for tablet screens
    const mobileDrawerOverlay = document.querySelector('[data-mobile-drawer-overlay]');
    
    // Body scroll lock for mobile drawer
    const lockBodyScroll = () => {
      // Only lock on mobile (below 1024px)
      if (window.innerWidth <= 1023) {
        body.classList.add('mobile-drawer-open');
      }
    };
    
    const unlockBodyScroll = () => {
      // Only unlock on mobile (below 1024px)
      if (window.innerWidth <= 1023) {
        body.classList.remove('mobile-drawer-open');
      }
    };

    // Force remove any overflow-hidden classes Shopify might add on drawer open
    const forceUnlockOverflow = () => {
      if (window.innerWidth <= 1023) {
        body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'mobile-drawer-open');
        html.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile');
        body.style.overflow = '';
        html.style.overflow = '';
      }
    };

    // Show/hide mobile drawer overlay for all mobile/tablet screens (below 1024px)
    const showMobileOverlay = () => {
      if (mobileDrawerOverlay && window.innerWidth <= 1023) {
        // Read current header bottom position so overlay starts below header
        const headerBottomRaw = getComputedStyle(document.documentElement).getPropertyValue(
          '--header-bottom-position'
        );
        const headerBottom = parseInt(headerBottomRaw || '0', 10) || 0;

        // Show overlay on all mobile/tablet screens below 1024px
        mobileDrawerOverlay.classList.add('is-active');
        // Force visibility with inline styles as backup to ensure it shows
        mobileDrawerOverlay.style.opacity = '1';
        mobileDrawerOverlay.style.visibility = 'visible';
        mobileDrawerOverlay.style.display = 'block';
        mobileDrawerOverlay.style.pointerEvents = 'auto';
        mobileDrawerOverlay.style.zIndex = '15'; // Below header (20) and drawer (999)
        mobileDrawerOverlay.style.position = 'fixed';
        // Start just under the header so header/logo are not dimmed
        mobileDrawerOverlay.style.top = `${headerBottom}px`;
        mobileDrawerOverlay.style.left = '0';
        mobileDrawerOverlay.style.right = '0';
        mobileDrawerOverlay.style.bottom = '0';
        mobileDrawerOverlay.style.width = '100vw';
        mobileDrawerOverlay.style.height = `calc(100vh - ${headerBottom}px)`;
        mobileDrawerOverlay.style.background = 'rgba(0, 0, 0, 0.35)';
      }
    };

    const hideMobileOverlay = () => {
      if (mobileDrawerOverlay) {
        mobileDrawerOverlay.classList.remove('is-active');
        // Reset inline styles
        mobileDrawerOverlay.style.opacity = '';
        mobileDrawerOverlay.style.visibility = '';
        mobileDrawerOverlay.style.display = '';
        mobileDrawerOverlay.style.pointerEvents = '';
        mobileDrawerOverlay.style.zIndex = '';
        mobileDrawerOverlay.style.position = '';
        mobileDrawerOverlay.style.top = '';
        mobileDrawerOverlay.style.left = '';
        mobileDrawerOverlay.style.right = '';
        mobileDrawerOverlay.style.bottom = '';
        mobileDrawerOverlay.style.width = '';
        mobileDrawerOverlay.style.height = '';
        mobileDrawerOverlay.style.background = '';
      }
    };
    
    /**
     * Reset mobile mega menu to top-level view
     * Updates ARIA attributes for accessibility
     */
    const resetMobileMegaView = () => {
      // Reset all menu states without animation (since drawer is closing)
      mobileMenuMain.classList.remove('hidden');
      mobileMenuMega.style.display = 'none';
      mobileMenuMega.style.opacity = '';
      mobileMenuMega.style.transform = '';
      const megaContentEl = mobileMenuMega.querySelector('.header-new__mobile-mega-content');
      if (megaContentEl) {
        megaContentEl.innerHTML = '';
        megaContentEl.removeAttribute('aria-label');
      }
      mobileMenuMega.dataset.state = '';
      // Reset all trigger ARIA attributes
      mobileMegaTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    };

    // Close mobile menu with smooth animation
    const closeMobileMenu = () => {
      if (mobileDrawerDetails && mobileMenuDrawer) {
        // Hide overlay and unlock body scroll
        hideMobileOverlay();
        unlockBodyScroll();
        forceUnlockOverflow();
        
        // Add closing class to trigger animation
        mobileMenuDrawer.classList.add('is-closing');
        
        // Wait for animation to complete before removing open attribute
        setTimeout(() => {
          if (mobileDrawerDetails) {
            mobileDrawerDetails.removeAttribute('open');
            // Remove closing class after a brief delay
            if (mobileMenuDrawer) {
              mobileMenuDrawer.classList.remove('is-closing');
            }
          }
          // Safety: ensure scroll unlock after animation completes
          forceUnlockOverflow();
          unlockBodyScroll();
          // Trigger close event for header-drawer component
          const headerDrawer = mobileDrawerDetails?.closest('header-drawer');
          if (headerDrawer && headerDrawer.closeMenuDrawer) {
            headerDrawer.closeMenuDrawer();
          }
          resetMobileMegaView();
        }, 800); // Match the transition duration (0.8s = 800ms)
      } else {
        hideMobileOverlay();
        unlockBodyScroll();
        forceUnlockOverflow();
        resetMobileMegaView();
      }
    };

    // Close button handler
    if (mobileDrawerClose) {
      mobileDrawerClose.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        closeMobileMenu();
      });
    }

    /**
     * Handle mobile drawer toggle with ARIA attribute updates
     */
    if (mobileDrawerDetails && mobileMenuDrawer) {
      const summary = mobileDrawerDetails.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', (e) => {
          // If drawer is currently open, we're about to close it
          if (mobileDrawerDetails.hasAttribute('open')) {
            // Update ARIA attributes
            summary.setAttribute('aria-expanded', 'false');
            mobileMenuDrawer.setAttribute('aria-hidden', 'true');
            
            // Add closing class to trigger smooth closing animation
            // Use requestAnimationFrame to ensure it happens before browser processes the click
            requestAnimationFrame(() => {
              if (mobileMenuDrawer && mobileDrawerDetails.hasAttribute('open')) {
                mobileMenuDrawer.classList.add('is-closing');
              }
            });
            
            // Remove closing class after animation completes
            setTimeout(() => {
              if (mobileMenuDrawer) {
                mobileMenuDrawer.classList.remove('is-closing');
              }
              hideMobileOverlay();
              unlockBodyScroll();
              resetMobileMegaView();
            }, 800);
          } else {
            // Opening - show overlay, lock body scroll and remove closing class if it exists
            summary.setAttribute('aria-expanded', 'true');
            mobileMenuDrawer.setAttribute('aria-hidden', 'false');
            showMobileOverlay();
            lockBodyScroll();
            mobileMenuDrawer.classList.remove('is-closing');
          }
        }, true); // Use capture phase to run before other handlers
      }
    }

    /**
     * Keep mobile drawer views in sync and update ARIA attributes
     */
    if (mobileDrawerDetails && mobileMenuDrawer) {
      mobileDrawerDetails.addEventListener('toggle', (e) => {
        const summary = mobileDrawerDetails.querySelector('summary');
        
        // When closing (open attribute has been removed)
        if (!mobileDrawerDetails.hasAttribute('open')) {
          // Update ARIA attributes
          if (summary) summary.setAttribute('aria-expanded', 'false');
          mobileMenuDrawer.setAttribute('aria-hidden', 'true');
          
          // Hide overlay and unlock body scroll
          hideMobileOverlay();
          unlockBodyScroll();
          
          // Ensure closing class is applied if not already
          if (!mobileMenuDrawer.classList.contains('is-closing')) {
            mobileMenuDrawer.classList.add('is-closing');
            setTimeout(() => {
              if (mobileMenuDrawer) {
                mobileMenuDrawer.classList.remove('is-closing');
              }
            }, 800);
          }
          resetMobileMegaView();
        } else {
          // When opening, show overlay, lock body scroll and remove closing class if it exists
          if (summary) summary.setAttribute('aria-expanded', 'true');
          mobileMenuDrawer.setAttribute('aria-hidden', 'false');
          showMobileOverlay();
          lockBodyScroll();
          mobileMenuDrawer.classList.remove('is-closing');
        }
      });
    }

    /**
     * Set up mobile mega menu trigger handlers
     * Updates ARIA attributes for accessibility
     */
    mobileMegaTriggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        // Prevent the default MenuDrawer button handler from firing,
        // otherwise it closes the whole drawer.
        e.preventDefault();
        e.stopImmediatePropagation();
        const blockId = trigger.getAttribute('data-mobile-mega-block');
        const title = trigger.getAttribute('data-mobile-mega-trigger');
        
        // Find the hidden mega menu data container
        const megaData = document.querySelector(`[data-mobile-mega-block-id="${blockId}"]`);
        
        if (megaData) {
          // Update ARIA attributes
          trigger.setAttribute('aria-expanded', 'true');
          const megaContentEl = mobileMenuMega.querySelector('.header-new__mobile-mega-content');
          if (megaContentEl) {
            megaContentEl.setAttribute('aria-label', `${title} submenu`);
          }
          // Clone the content to avoid removing it from the original location
          const megaContent = megaData.innerHTML;
          const headerTitleEl = mobileMenuMega.querySelector('.header-new__mobile-mega-back-title');
          const rootTitle = title;
          if (headerTitleEl) {
            headerTitleEl.textContent = rootTitle;
          }
          mobileMenuMega.dataset.rootTitle = rootTitle;

          // Ensure body scroll is locked and overlay is shown when opening mega menu
          lockBodyScroll();
          showMobileOverlay();
          
          // Smooth transition to mega menu
          mobileMenuMega.querySelector('.header-new__mobile-mega-content').innerHTML = megaContent;
          
          // Prepare mega menu for animation
          mobileMenuMega.style.display = 'block';
          mobileMenuMega.style.opacity = '0';
          mobileMenuMega.style.transform = 'translateX(20px)';
          
          // Hide main menu with smooth transition
          mobileMenuMain.classList.add('hidden');
          
          // Trigger smooth entrance animation for mega menu
          requestAnimationFrame(() => {
            mobileMenuMega.style.opacity = '1';
            mobileMenuMega.style.transform = 'translateX(0)';
          });
          
          // Scroll to top of mega menu
          mobileMenuMega.scrollTop = 0;

          // Bind second/third-level handlers inside the injected mega content
          const sectionList = mobileMenuMega.querySelector('[data-mobile-submega-list]');
          const subPanels = mobileMenuMega.querySelectorAll('[data-mobile-submega-panel]');
          const featuredBlock = mobileMenuMega.querySelector('.header-new__mobile-mega-featured');

          const showSectionList = () => {
            // Smooth transition back to sections
            subPanels.forEach((panel) => {
              panel.style.opacity = '0';
              panel.style.transform = 'translateX(-20px)';
              setTimeout(() => {
                panel.style.display = 'none';
              }, 400);
            });
            
            if (sectionList) {
              sectionList.style.display = '';
              sectionList.style.opacity = '0';
              sectionList.style.transform = 'translateX(-20px)';
              requestAnimationFrame(() => {
                sectionList.style.opacity = '1';
                sectionList.style.transform = 'translateX(0)';
              });
            }
            
            if (featuredBlock) {
              featuredBlock.style.display = '';
              featuredBlock.style.opacity = '0';
              requestAnimationFrame(() => {
                featuredBlock.style.opacity = '1';
              });
            }
            
            if (headerTitleEl) headerTitleEl.textContent = mobileMenuMega.dataset.rootTitle || rootTitle;
            mobileMenuMega.dataset.state = 'sections';
          };

          // Initial state: only 3 titles visible
          showSectionList();

          /**
           * Set up submega trigger handlers with ARIA attribute updates
           */
          mobileMenuMega
            .querySelectorAll('[data-mobile-submega-trigger]')
            .forEach((btn) => {
              btn.addEventListener('click', () => {
                const target = btn.getAttribute('data-mobile-submega-trigger');
                const panel = mobileMenuMega.querySelector(
                  `[data-mobile-submega-panel="${target}"]`
                );
                if (!panel) return;
                
                // Update ARIA attributes
                btn.setAttribute('aria-expanded', 'true');
                panel.setAttribute('aria-hidden', 'false');
                // Close other panels
                subPanels.forEach((p) => {
                  if (p !== panel) {
                    p.setAttribute('aria-hidden', 'true');
                  }
                });
                
                // Smooth transition: hide sections and show panel
                if (sectionList) {
                  sectionList.style.opacity = '0';
                  sectionList.style.transform = 'translateX(-20px)';
                  setTimeout(() => {
                    sectionList.style.display = 'none';
                  }, 400);
                }
                
                subPanels.forEach((p) => {
                  p.style.opacity = '0';
                  p.style.display = 'none';
                });
                
                // Show target panel with smooth animation
                panel.style.display = 'block';
                panel.style.opacity = '0';
                panel.style.transform = 'translateX(20px)';
                requestAnimationFrame(() => {
                  panel.style.opacity = '1';
                  panel.style.transform = 'translateX(0)';
                });
                
                if (featuredBlock) {
                  featuredBlock.style.opacity = '0';
                  setTimeout(() => {
                    featuredBlock.style.display = 'none';
                  }, 200);
                }
                
                const labelSpan = btn.querySelector('span');
                if (headerTitleEl && labelSpan) {
                  headerTitleEl.textContent = labelSpan.textContent.trim();
                }
                mobileMenuMega.dataset.state = 'sub';
              });
            });

          // Handle submega back buttons (inside panels)
          mobileMenuMega
            .querySelectorAll('[data-mobile-submega-back]')
            .forEach((backBtn) => {
              backBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                
                // Ensure the drawer stays open
                if (mobileDrawerDetails && !mobileDrawerDetails.hasAttribute('open')) {
                  mobileDrawerDetails.setAttribute('open', '');
                }
                
                // Smooth transition back to sections view
                subPanels.forEach((panel) => {
                  panel.style.opacity = '0';
                  panel.style.transform = 'translateX(20px)';
                  setTimeout(() => {
                    panel.style.display = 'none';
                  }, 400);
                });
                
                if (sectionList) {
                  sectionList.style.display = '';
                  sectionList.style.opacity = '0';
                  sectionList.style.transform = 'translateX(-20px)';
                  requestAnimationFrame(() => {
                    sectionList.style.opacity = '1';
                    sectionList.style.transform = 'translateX(0)';
                  });
                }
                
                if (featuredBlock) {
                  featuredBlock.style.display = '';
                  featuredBlock.style.opacity = '0';
                  requestAnimationFrame(() => {
                    featuredBlock.style.opacity = '1';
                  });
                }
                
                if (headerTitleEl) {
                  headerTitleEl.textContent = mobileMenuMega.dataset.rootTitle || '';
                }
                mobileMenuMega.dataset.state = 'sections';
                
                return false;
              });
            });
        }
      });
    });

    /**
     * Back button handler with ARIA attribute updates
     * Supports both click and keyboard navigation
     */
    if (mobileMegaBack) {
      // Use capture phase to handle before header-drawer component
      const handleBackClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // If we are inside a third-level sub section, go back to the 3‑title list
        if (mobileMenuMega.style.display === 'block' && mobileMenuMega.dataset.state === 'sub') {
          const sectionList = mobileMenuMega.querySelector('[data-mobile-submega-list]');
          const subPanels = mobileMenuMega.querySelectorAll('[data-mobile-submega-panel]');
          const featuredBlock = mobileMenuMega.querySelector('.header-new__mobile-mega-featured');
          
          // Update ARIA attributes - close all sub panels
          subPanels.forEach((panel) => {
            panel.setAttribute('aria-hidden', 'true');
          });
          const activeSubTrigger = mobileMenuMega.querySelector('[data-mobile-submega-trigger][aria-expanded="true"]');
          if (activeSubTrigger) {
            activeSubTrigger.setAttribute('aria-expanded', 'false');
          }
          
          // Smooth transition back to sections
          subPanels.forEach((panel) => {
            panel.style.opacity = '0';
            panel.style.transform = 'translateX(20px)';
            setTimeout(() => {
              panel.style.display = 'none';
            }, 400);
          });
          
          if (sectionList) {
            sectionList.style.display = '';
            sectionList.style.opacity = '0';
            sectionList.style.transform = 'translateX(-20px)';
            requestAnimationFrame(() => {
              sectionList.style.opacity = '1';
              sectionList.style.transform = 'translateX(0)';
            });
          }
          
          if (featuredBlock) {
            featuredBlock.style.display = '';
            featuredBlock.style.opacity = '0';
            requestAnimationFrame(() => {
              featuredBlock.style.opacity = '1';
            });
          }
          
          const headerTitleEl = mobileMenuMega.querySelector('.header-new__mobile-mega-back-title');
          if (headerTitleEl) {
            headerTitleEl.textContent = mobileMenuMega.dataset.rootTitle || headerTitleEl.textContent;
          }
          mobileMenuMega.dataset.state = 'sections';
        } else if (mobileMenuMega.style.display === 'block' && (mobileMenuMega.dataset.state === 'sections' || !mobileMenuMega.dataset.state)) {
          // If we are at the sections level (initial mega menu view) or in two-cards layout,
          // go back to main menu but keep the drawer open - with smooth transition
          // Update ARIA attributes
          mobileMegaTriggers.forEach((trigger) => {
            if (trigger.getAttribute('aria-expanded') === 'true') {
              trigger.setAttribute('aria-expanded', 'false');
            }
          });
          
          mobileMenuMega.style.opacity = '0';
          mobileMenuMega.style.transform = 'translateX(20px)';
          setTimeout(() => {
            mobileMenuMega.style.display = 'none';
            mobileMenuMain.classList.remove('hidden');
            const megaContentEl = mobileMenuMega.querySelector('.header-new__mobile-mega-content');
            if (megaContentEl) {
              megaContentEl.innerHTML = '';
              megaContentEl.removeAttribute('aria-label');
            }
            mobileMenuMega.dataset.state = '';
          }, 400);
        }
        
        // Explicitly ensure drawer stays open - use multiple approaches
        if (mobileDrawerDetails) {
          mobileDrawerDetails.setAttribute('open', '');
          // Use requestAnimationFrame to ensure it happens after any other handlers
          requestAnimationFrame(() => {
            if (mobileDrawerDetails && !mobileDrawerDetails.hasAttribute('open')) {
              mobileDrawerDetails.setAttribute('open', '');
            }
          });
          // Also use setTimeout as backup
          setTimeout(() => {
            if (mobileDrawerDetails && !mobileDrawerDetails.hasAttribute('open')) {
              mobileDrawerDetails.setAttribute('open', '');
            }
          }, 10);
        }
        
        return false;
      };
      
      // Add click listener in capture phase (runs before bubbling phase)
      mobileMegaBack.addEventListener('click', handleBackClick, true);
      
      // Add keyboard support (Enter and Space keys)
      mobileMegaBack.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          handleBackClick(e);
        }
      });
    }

    // Handle overlay click to close drawer (for tablet screens)
    if (mobileDrawerOverlay) {
      mobileDrawerOverlay.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        forceUnlockOverflow();
        unlockBodyScroll();
        closeMobileMenu();
      });
    }

    /**
     * Handle window resize - unlock scroll if window becomes desktop size
     * Optimized with debouncing for performance
     */
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // If window is resized to desktop size while drawer might be open, unlock scroll
        if (window.innerWidth > 1023) {
          hideMobileOverlay();
          unlockBodyScroll();
        } else if (window.innerWidth <= 1023 && mobileDrawerDetails && mobileDrawerDetails.hasAttribute('open')) {
          // If resized back to mobile and drawer is open, show overlay and lock again
          // Show overlay on all mobile screens below 1024px
          showMobileOverlay();
          lockBodyScroll();
        }
      }, 100);
    });

    /**
     * Global keyboard support for mobile drawer
     * Escape key closes the drawer
     */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileDrawerDetails && mobileDrawerDetails.hasAttribute('open')) {
        closeMobileMenu();
      }
    });
  }
});

/**
 * Header scroll handler for homepage transparency
 * Optimized with passive event listeners and requestAnimationFrame for performance
 * Runs immediately to handle initial scroll state
 */
(function() {
  let ticking = false;
  
  const initHeaderScroll = () => {
    const headerWrapper = document.querySelector('.section-header-new');
    const body = document.body;
    const html = document.documentElement;
    
    if (!headerWrapper || !body.classList.contains('is-homepage')) {
      return;
    }
    
    /**
     * Handle scroll event with throttling using requestAnimationFrame
     * Updates header appearance based on scroll position
     */
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          
          // Add 'scrolled' class when scrolled more than 60px
          if (scrollY > 60) {
            if (!headerWrapper.classList.contains('scrolled')) {
              headerWrapper.classList.add('scrolled');
            }
          } else {
            // Only remove scrolled class if mega menu is not open
            if (!headerWrapper.classList.contains('mega-menu-open') && !html.classList.contains('mega-open')) {
              headerWrapper.classList.remove('scrolled');
            }
          }
          
          ticking = false;
        });
        
        ticking = true;
      }
    };
    
    // Check initial scroll position
    handleScroll();
    
    // Listen to scroll events with passive flag for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
  };
  
  // Try to initialize immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScroll);
  } else {
    initHeaderScroll();
  }
  
  // Also try after a small delay to ensure header is rendered
  setTimeout(initHeaderScroll, 100);
})();

(function() {
  let ticking = false;
  
  const initAnnouncementBarScroll = () => {
    const announcementBarWrapper = document.querySelector('.announcement-bar-wrapper');
    const body = document.body;
    
    if (!announcementBarWrapper || !body.classList.contains('is-homepage')) {
      return;
    }
    
    /**
     * Handle scroll event with throttling using requestAnimationFrame
     * Updates announcement bar appearance based on scroll position
     */
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
          
          // Add 'scrolled' class when scrolled more than 60px
          if (scrollY > 60) {
            if (!announcementBarWrapper.classList.contains('scrolled')) {
              announcementBarWrapper.classList.add('scrolled');
            }
          } else {
            announcementBarWrapper.classList.remove('scrolled');
          }
          
          ticking = false;
        });
        
        ticking = true;
      }
    };
    
    // Check initial scroll position
    handleScroll();
    
    // Listen to scroll events with passive flag for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });
  };
  
  // Try to initialize immediately
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementBarScroll);
  } else {
    initAnnouncementBarScroll();
  }
  
  // Also try after a small delay to ensure announcement bar is rendered
  setTimeout(initAnnouncementBarScroll, 100);
})();


